module.exports = __webpack_public_path__ + "static/media/Icon-CV_Set 2_Pro.9ba63055.svg";